import React from 'react'
import { format } from 'date-fns'
import { ReviewTrailStep } from '@marketing-milk/interfaces'
import { dark, radius, type as typo } from '../tokens'

const day = (iso: string) => format(new Date(iso), 'MMM d')

const stepText = (step: ReviewTrailStep): string => {
  if (step.kind === 'not-edited') return 'Not edited since'
  if (step.kind === 'edited') return `Edited ${day(step.at)}`
  const verdict = `${step.approved ? 'Approved' : 'Rejected'} ${day(step.at)}`
  return step.reason ? `${verdict}: “${step.reason}”` : verdict
}

/**
 * The short "what happened since the client looked" trail under a review card's
 * image (DRI-190): the verdict, the edit that answered it, and the current
 * verdict if it came after. The reason is cut to one line; the full text and
 * every earlier step stay in the ad's history.
 *
 * "Not edited since" is the one line asking for work, so it's the one in amber.
 */
export function ReviewTrailLines({ steps }: { steps: ReviewTrailStep[] }) {
  return (
    <div
      style={{
        borderRadius: radius.sm,
        background: dark.bg,
        border: `1px solid ${dark.hairline}`,
        padding: '8px 10px',
        display: 'flex',
        flexDirection: 'column',
        gap: 3,
        fontFamily: typo.family.sans,
        fontSize: 13,
      }}
    >
      {steps.map((step, i) => (
        <span
          key={i}
          style={
            i === 0
              ? {
                  color: dark.text,
                  whiteSpace: 'nowrap',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                }
              : step.kind === 'not-edited'
              ? { color: dark.status.warn, fontWeight: typo.weight.medium }
              : { color: dark.textMuted }
          }
        >
          {stepText(step)}
        </span>
      ))}
    </div>
  )
}
